import { render, staticRenderFns } from "./DataWrapper.vue?vue&type=template&id=4fea769e&"
import script from "./DataWrapper.vue?vue&type=script&lang=js&"
export * from "./DataWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports